import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { AppState } from '@cpd-app/state';
import { selectLoading, selectMaintance } from './maintance.selectors';
import { filter, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MaintanceFacade {
  public readonly maintanceStatus$ = this.store.select(selectMaintance);

  public readonly alert$ = this.store
    .select(selectMaintance)
    .pipe(map((res) => res?.message));

  public readonly bannerActive$ = this.store
    .select(selectMaintance)
    .pipe(map((res) => res?.banneractive));

  public readonly siteBlocked$ = this.store.select(selectMaintance).pipe(
    filter((res) => res !== undefined), // there is case api return null
    map((res) => !!res?.siteblocked)
  );

  public readonly isLoading$ = this.store.select(selectLoading);

  constructor(private store: Store<AppState>) {}
}
